import { useState } from "react";
import { format } from "date-fns";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid2 from "@mui/material/Grid2";
import { connect } from "react-redux";
import MuiDatePicker from "../../../Common/FormInputs/MuiDatePicker";
import AppButton from "../../../Common/Button/Button";
import Alert from "../../../layout/Alert";
import { SectionHeading, LabelText } from "../../../Common/Typography/AppTypography";
import { setAlert } from "../../../../action/alert";

const fieldWrapperSx = { mb: 0 };
const labelTopSx = { mb: 1, minHeight: 20, display: "block", fontWeight: 500 };

const DACCount = ({ dacData, getDACCount, setCustomAlert }) => {
    const [startDateFilter, setStartDateFilter] = useState(null);
    const [endDateFilter, setEndDateFilter] = useState(null);
    const [showDACData, setShowDACData] = useState(false);

    const handleStartDateChange = (date) => {
        setStartDateFilter(date ? date.getTime() : null);
        setEndDateFilter(null);
        setShowDACData(false);
    };

    const handleEndDateChange = (date) => {
        setEndDateFilter(date ? date.getTime() : null);
        setShowDACData(false);
    };

    const filter = () => {
        if (startDateFilter === null) {
            setCustomAlert("Start Date Cannot be Empty", "danger");
            return;
        }
        if (endDateFilter === null) {
            setCustomAlert("End Date Cannot be Empty", "danger");
            return;
        }
        setShowDACData(false);
        const startDate = format(new Date(Number(startDateFilter)), "dd-MM-yyyy");
        const endDate = format(new Date(Number(endDateFilter)), "dd-MM-yyyy");
        getDACCount({ startTs: startDate, endTs: endDate }, () => setShowDACData(true));
    };

    return (
        <Box sx={{ width: "100%", minWidth: 0 }}>
            <Paper sx={{ p: 2, boxShadow: 2, borderRadius: 1, mb: 2 }}>
                <Alert />
                <Grid2 container spacing={2} alignItems="flex-end">
                    <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                        <Box sx={fieldWrapperSx}>
                            <LabelText sx={labelTopSx}>From:</LabelText>
                            <MuiDatePicker
                                label="Start Date"
                                value={startDateFilter ? new Date(startDateFilter) : null}
                                maxDate={new Date()}
                                onChange={handleStartDateChange}
                            />
                        </Box>
                    </Grid2>
                    <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                        <Box sx={fieldWrapperSx}>
                            <LabelText sx={labelTopSx}>To:</LabelText>
                            <MuiDatePicker
                                label="End Date"
                                value={endDateFilter ? new Date(endDateFilter) : null}
                                minDate={startDateFilter ? new Date(startDateFilter) : undefined}
                                maxDate={new Date()}
                                onChange={handleEndDateChange}
                            />
                        </Box>
                    </Grid2>
                    <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 2 }}>
                        <Box
                            sx={{
                                pt: { xs: 0, sm: "28px" }, // aligns button baseline with date fields
                                display: "flex",
                                width: "100%",
                            }}
                        >
                            <AppButton
                                variant="primary"
                                size="medium"
                                onClick={filter}
                                sx={{ minWidth: 100, height: 40, width: { xs: "100%", sm: "auto" } }}
                            >
                                Filter
                            </AppButton>
                        </Box>
                    </Grid2>
                </Grid2>
            </Paper>

            {showDACData && (
                <Paper sx={{ p: 2, boxShadow: 2, borderRadius: 1 }}>
                    <SectionHeading sx={{ m: 0, mb: 1 }}>
                        DAC Count : {dacData?.hasOwnProperty("count") ? dacData?.count : "-"}
                    </SectionHeading>
                </Paper>
            )}
        </Box>
    );
};

const mapDispatchToProps = (dispatch) => ({
    setCustomAlert: (message, alertType) => dispatch(setAlert(message, alertType)),
});

export default connect(null, mapDispatchToProps)(DACCount);
